import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const imgPos = {
  "lifestyle-concierge-schweiz": "object-[50%_60%]",
  "persoenliche-assistenz": "object-[50%_22%]",
  "relocation-services-schweiz": "object-center",
  "home-property-management": "object-center",
  "executive-family-assistance": "object-[50%_28%]",
};

export const Services = ({ t, lang }) => (
  <section id="leistungen" className="bg-sand/60 border-y border-line py-24 md:py-36" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-xs uppercase tracking-[0.25em] font-bold text-taupe mb-6"
        data-testid="services-overline"
      >
        {t.services.overline}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="font-heading font-light tracking-tight text-4xl md:text-5xl max-w-3xl leading-[1.05]"
        data-testid="services-title"
      >
        {t.services.title}
      </motion.h2>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {t.services.items.map((s, i) => (
          <motion.article
            key={s.number}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="group bg-sand hover:bg-sandhover transition-colors duration-500 flex flex-col"
            data-testid={`service-card-${i + 1}`}
          >
            <div className="overflow-hidden h-72 md:h-80 lg:h-[22rem]">
              <img
                src={s.image}
                alt={s.alt}
                loading="lazy"
                className={`w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${imgPos[s.slug] || "object-center"}`}
                data-testid={`service-image-${i + 1}`}
              />
            </div>
            <div className="p-8 md:p-10 flex flex-col flex-1">
              <span className="font-heading italic text-taupe text-xl">{s.number}</span>
              <h3 className="mt-4 font-heading text-2xl md:text-3xl font-medium leading-tight" data-testid={`service-title-${i + 1}`}>
                {s.title}
              </h3>
              <p className="mt-5 text-smoke text-sm md:text-base font-light leading-relaxed flex-1" data-testid={`service-desc-${i + 1}`}>
                {s.desc}
              </p>
              <Link
                to={s.to ? (lang === "de" ? s.to : s.toEn) : `/leistungen/${s.slug}`}
                data-testid={`service-link-${i + 1}`}
                className="mt-8 inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-ink group-hover:text-taupe transition-colors duration-300"
              >
                {t.services.more}
                <ArrowUpRight size={15} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
